<template>
  <div class="get-in-touch-component screen">
    <div class="header-band">
      <AdminModalMenu @close="beforeClose()" />
      <div class="title-group">
        <span class="title">Contact Netstar</span>
        <div class="divider"></div>
        <span class="subtitle">Get in touch</span>
      </div>
      <CloseButton variant="light" inline @click="beforeClose()" />
    </div>
    <div class="subheading">Emergency number</div>
    <div class="panel mb-3">
      <img src="~@/assets/images/phone.svg" class="phone-icon" height="34" />
      <a href="tel:0800112222">0800 11 22 22</a>
    </div>
    <div class="subheading">Customer support & sales</div>
    <div class="panel mb-3">
      <img src="~@/assets/images/phone.svg" class="phone-icon" height="34" />
      <a href="tel:0860122436">0860 12 24 36</a>
      <div class="block">
        <template v-if="$isMobile">
          <div class="mb-2">
            <img src="~@/assets/images/email.svg" class="email-icon" height="34" />
            <a href="mailto:cs@netstar.co.za">cs@netstar.co.za</a>
          </div>
          <div>
            <img src="~@/assets/images/email.svg" class="email-icon" height="34" />
            <a href="mailto:sales@netstar.co.za">sales@netstar.co.za</a>
          </div>
        </template>
        <template v-else>
          <img src="~@/assets/images/email.svg" class="email-icon" height="34" />
          <a href="mailto:cs@netstar.co.za">cs@netstar.co.za</a>
          <span class="divider">|</span>
          <a href="mailto:sales@netstar.co.za">sales@netstar.co.za</a>
        </template>
      </div>
    </div>
    <div class="panel last">
      <div class="subheading">Chat now!</div>
      <div class="box container">
        <div class="row">
          <img src="~@/assets/images/whatsapp.svg" class="whatsapp-icon" height="34" />
          <div class="col">
            <a href="https://api.whatsapp.com/send?phone=27860122436" target="_blank">0860 12 24 36</a>
            <br />
            <a href="https://www.netstar.co.za/service-bot" target="_blank">www.netstar.co.za/service-bot</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.get-in-touch-component {
  .header-band {
    display: flex;
    align-items: center;
    background-color: $brand-color-1;
    height: 54px;
    padding: 0 30px;
    margin: -20px -30px 25px -30px;
    color: #fff;
    position: relative;
    font-size: 1.1875rem;

    /deep/ .menu-button .icon {
      fill: #fff;
    }

    .title-group {
      display: flex;
      align-items: center;
      flex: 1;
    }

    .title {
      font-weight: 600;
      color: #fff;
      margin-left: 5px;
    }

    .divider {
      width: 1px;
      height: 20px;
      background-color: #fff;
      margin: 0 15px;

      &.divider-wide {
        margin: 0 40px 0 15px;
      }
    }

    .subtitle {
      color: #fff;
    }

    @media (max-width: 767px) {
      align-items: flex-start;

      .title-group {
        flex-direction: column;
        align-items: flex-start;
      }

      .title {
        font-weight: 600;
        font-size: 19px;
        margin-left: 0;
      }

      .divider {
        display: none;
      }

      .subtitle {
        font-weight: 300;
        font-size: 19px;
      }
    }
  }

  .subheading {
    font-size: 16px;
    color: $brand-color-2;
    font-weight: 600;
    padding-bottom: 0.5rem;
  }

  .panel {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background: $brand-color-4;
    padding: 5px 5px;

    &.last {
      padding-bottom: 15px;

      .box {
        background: #fff;
        padding: 10px 15px;
        border: 1px solid $brand-color-2;

        .row {
          align-items: center;
        }

        a:first-child {
          text-decoration: underline;
        }
      }
    }

    a {
      color: $brand-color-1;
    }

    .phone-icon,
    .email-icon,
    .whatsapp-icon {
      width: 34px;
      height: 34px;
      object-fit: contain;
    }

    .phone-icon,
    .email-icon {
      margin-right: 8px;
    }

    .whatsapp-icon {
      margin: auto 0px auto 20px;
    }

    .block {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: calc(100% + 10px);
      background: $brand-color-4;
      padding: 5px 4px;
      margin: 5px -5px -5px -5px;

      > div {
        display: flex;
        align-items: center;
      }

      .divider {
        display: inline-block;
        margin: 0 5px;
      }
    }
  }
}

@media (max-width: $md-1) {
  .get-in-touch-component {
    .header-band {
      background-color: #fff;
      color: $brand-color-1;
      margin-top: -5px;

      /deep/ .menu-button .icon {
        fill: $brand-color-1;
      }

      .title {
        color: $brand-color-1;
      }

      .divider {
        background-color: $brand-color-1;
      }

      .subtitle {
        color: $brand-color-1;
      }

      /deep/ .close-button svg path {
        fill: $brand-color-1;
      }
    }
  }
}
</style>

<script>
import { adminService } from "@/services";
import { helper } from "@/helper";
import AdminModalMenu from "@/components/screens/AdminModalMenu";
import CloseButton from "@/components/CloseButton";

export default {
  name: "GetInTouch",
  components: {
    AdminModalMenu,
    CloseButton,
  },
  methods: {
    beforeClose() {
      this.$emit("close");
    },
  },
};
</script>